import React, { useState, useRef, useEffect, useContext } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Icon } from "@iconify/react";
import ReminderCard from "../../components/cards/reminderCard";
import { Select } from "antd";
import Linechart from "../../components/dashboard/linechart";
import { getAllReminders } from "../../APIs/remindersApis";
import { AppContext } from "../../context/AppContext";
import { useTranslation } from "react-i18next";
import { getAllCasesStatistics } from "../../APIs/caseApis";

const Dashboardmain = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const [selectedDate, setSelectedDate] = useState(new Date());
  const { allreminders } = useContext(AppContext);
  const [allCasesStats, setAllCasesStats] = useState({
    totalCases : 0,
    monthlyCases: 0,
    casesThisMonth : 0,
    averageCasesPerMonth : [],
  });

  const datePickerRef = useRef(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  // Function to trigger DatePicker focus when clicking the icon
  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };

  useEffect(() => {
    getAllCasesStatistics().then((res) => {
      // console.log(res);
      setAllCasesStats({
        totalCases : res.totalCases,
    monthlyCases: res.monthlyCases,
    casesThisMonth : res.casesThisMonth,
    averageCasesPerMonth : res.averageCasesPerMonth,
      });
    }).catch((err) => {
      console.log(err);
    })
  },[])
  const months = [
    t("dashboard.home.performance.months.january"),
    t("dashboard.home.performance.months.march"),
    t("dashboard.home.performance.months.may"),
    t("dashboard.home.performance.months.july"),
    t("dashboard.home.performance.months.august"),
    t("dashboard.home.performance.months.october"),
    t("dashboard.home.performance.months.november"),
  ];
  return (
    <>
      <div className="dashboard-main flex flex-col gap-[31px] pt-[30px]">
        <div className="top flex gap-[20px] sm-s:flex-col">
          <div className="cases-div flex flex-col gap-[20px]  max-w-[25%] sm-s:max-w-[100%] w-full">
            <div class=" flex flex-col items-center justify-center h-full pt-[18px] pb-[21px] px-[10px] gap-[6px] rounded-[16px] bg-[rgba(255,255,255,0.80)] backdrop-blur-[53px]">
              <p className="text-blue font-semibold large">
                {t("dashboard.home.cases.activeCases")}
              </p>
              <h4 className="esmall font-semibold text-blue">
                <span className="text-secondary">{allCasesStats && allCasesStats.totalCases }</span>
              </h4>
            </div>
            <div class="flex flex-col items-center justify-center h-full pt-[18px] pb-[21px] px-[10px] gap-[6px] rounded-[16px] bg-[rgba(255,255,255,0.80)] backdrop-blur-[53px]">
              <p className="text-blue font-semibold large">{t("dashboard.home.cases.newCases")}</p>
              <h4 className="esmall font-semibold text-blue">{allCasesStats && allCasesStats.casesThisMonth}</h4>
            </div>
            <div class="flex flex-col items-center justify-center h-full pt-[18px] pb-[21px] px-[10px] gap-[6px] rounded-[16px] bg-[rgba(255,255,255,0.80)] backdrop-blur-[53px]">
              <p className="text-blue font-semibold large text-center">
                {t("dashboard.home.cases.averageCaseDuration")}
              </p>
              <h4 className="esmall font-semibold text-blue ">
                {allCasesStats && allCasesStats.averageCasesPerMonth}<span className="text-secondary pl-[9px]">month</span>
              </h4>
            </div>
          </div>
          <div class="reminder-div  flex flex-col gap-[25px] max-w-[75%] sm-s:max-w-[100%] w-full pt-[23px] px-[33px] sm-s:px-[20px] rounded-[20px] border-[1.299px] border-[rgba(255,255,255,0.28)] bg-[#F8F8F8] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)]">
            <div className="reminder-top flex justify-between sm-s:flex-col gap-[20px]">
              <h4 className="esmall font-semibold text-blue">
                {t("dashboard.home.reminders.title")} {"("} {allreminders && allreminders.length} {")"}
              </h4>
              <div className="flex items-center gap-[8px] sm-s:justify-end">
                <p className="text-blue font-medium small font-montserrat">Date:</p>
                <div className="flex items-center gap-[10px]  rounded-[10px] p-[10px] border-[var(--stroke-weight-1,1px)] border-[var(--border,#FFF)] bg-[rgba(255,255,255,0.60)] drop-shadow-md">
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    className="text-[#8D8D8D] bg-transparent font-medium small font-montserrat"
                    dateFormat="MM/dd/yyyy"
                    ref={datePickerRef} // Assign the ref to DatePicker
                  />
                  <Icon
                    icon="clarity:date-line"
                    className="text-gray-500 cursor-pointer"
                    onClick={handleIconClick} // Trigger DatePicker on icon click
                  />
                </div>
              </div>
            </div>
            <div className="reminder-card-wrapper bg-transparent flex flex-col gap-[7px] pr-[22px] sm-s:pr-[11px] max-h-[322px] overflow-y-auto">
              <ReminderCard />
            </div>
          </div>
        </div>
        <div className="bottom flex flex-col gap-[43px] drop-shadow-md rounded-[21px] px-[50px] sm-s:px-[20px] py-[15px] border-[rgba(255,255,255,0.28)] bg-[#F4F4F4] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)]">
          <div className="performance flex justify-between items-center">
            <p className="text-blue font-semibold large">{t("dashboard.home.performance.title")}</p>
            <Select placeholder="Year" style={{ width: 108 }} className="graph-dropdown">
              {months.map((month, index) => (
                <Option key={index} value={month}>
                  {month}
                </Option>
              ))}
            </Select>
          </div>
          <Linechart />
        </div>
      </div>
    </>
  );
};

export default Dashboardmain;
